import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../environments/environment';
import { formatDate } from '@angular/common';
import { Detection, Facility, ManualDetectionSummarySet } from '../types/common.types';

@Injectable({
  providedIn: 'root'
})

export class BackendService {

  constructor(private http: HttpClient) { }

  facilities(): Observable<Facility[]>  {
    const url = environment.apiUrl + '/facilities';
    const httpParams = new HttpParams()
    const options = {params: httpParams};
    return this.http.get<Facility[]>(url,options);
  }

  detections(facilityId: number, startTime: Date, endTime: Date, granularityInHours: number, periodGranularity:string): Observable<Detection[]>{
    const url = environment.apiUrl + '/detections/manual';
    const httpParams = new HttpParams()
    .set('facilityId', facilityId.toString())
    .set('startTime', formatDate(startTime, 'yyyy-MM-dd', 'en-DK'))
    .set('endTime', formatDate(endTime, 'yyyy-MM-dd', 'en-DK'))
    .set('granularityInHours', granularityInHours)
    .set('periodGranularity', periodGranularity);
    const options = {params: httpParams};
    return this.http.get<Detection[]>(url, options);
  }

    allDetections(startTime: Date, endTime: Date, granularityInHours: number, periodGranularity:string): Observable<ManualDetectionSummarySet[]>{
    const url = environment.apiUrl + '/detections/all-manual';
    const httpParams = new HttpParams()
    .set('startTime', formatDate(startTime, 'yyyy-MM-dd', 'en-DK'))
    .set('endTime', formatDate(endTime, 'yyyy-MM-dd', 'en-DK'))
    .set('granularityInHours', granularityInHours)
    .set('periodGranularity', periodGranularity);
    const options = {params: httpParams};
    return this.http.get<ManualDetectionSummarySet[]>(url, options);
  }

  setDetections(id:number, organization_id: number, department_id:number, facility_id: number, count:number, count_time: Date){
    const url = environment.apiUrl + '/detections/manual/' + id;
    let offset = count_time.getTimezoneOffset();
    offset = Math.abs(offset / 60);

    const modifiedCountTime = new Date(count_time);
    modifiedCountTime.setHours(modifiedCountTime.getHours() + offset);

    return this.http.patch(url, {
      id: id,
      organization_id: organization_id,
      department_id: department_id,
      facility_id: facility_id,
      count: count,
      count_time: modifiedCountTime.toISOString()
    }, { observe: 'response' });
  }

  createDetection(count:number, organization_id: number, department_id:number, facility_id: number, count_time: Date){
    const url = environment.apiUrl + '/detections/manual';
    let offset = count_time.getTimezoneOffset();
    offset = Math.abs(offset / 60);

    const modifiedCountTime = new Date(count_time);
    modifiedCountTime.setHours(modifiedCountTime.getHours() + offset);

    return this.http.post(url, {
      count: count,
      organization_id: organization_id,
      department_id: department_id,
      facility_id: facility_id,
      count_time: modifiedCountTime.toISOString()
    }, { observe: 'response' });
  }
}
